import * as React from "react";
import styled from "styled-components";

import { Field } from "redux-form";

import BtnBorderLarge from "../../atom/btn/btn_border_large";
import BtnCorporateLarge from "../../atom/btn/btn_corporate_large";

import { RefObject } from "react";
import {
  ConstBreakPoint,
  ConstColor,
  ConstWidth,
} from "../../../../config/styles_const/styles_const";
import * as Validator from "../../../../util/validation";
import ParagraphSup from "../../atom/text/paragraph_sup";
import FormGroupTextareaConnectRf from "../../molecular/form_group/form_group_textarea_connect_rf";

interface IProps {
  onchange: any;
  textareaRef?: RefObject<HTMLTextAreaElement>;
  disabled: any;
  imageError?: any;
  formValues?: any;
  error?: any;
}

const MessagePost: React.FC<IProps> = (props) => {
  const { onchange, textareaRef, disabled, imageError, formValues } = props;

  return (
    <Outer>
      {imageError && <ErrorTxt bold={true}>{imageError}</ErrorTxt>}
      {!imageError && formValues && (
        <ErrorTxt icon='"\f0c6"' bold={true}>
          添付ファイル
        </ErrorTxt>
      )}
      <Wrapper>
        <Label htmlFor="upload-button">
          <FileBtn as={"div"} icon='"\f0c6"' />
          <Input
            id="upload-button"
            name="upload-button"
            onChange={onchange}
            accept="
                                application/pdf,
                                application/vnd.ms-powerpoint,
                                application/vnd.openxmlformats-officedocument.presentationml.presentation,
                                application/msword,
                                application/vnd.openxmlformats-officedocument.wordprocessingml.document,
                                application/vnd.ms-excel,
                                application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            multiple={false}
            type="file"
          />
        </Label>
        <Field
          placeholder="メッセージを入力してください"
          name="message"
          component={FormGroupTextareaConnectRf}
          type="text"
          validate={[Validator.messageText]}
          textareaRef={textareaRef}
        />

        <SubmitBtn
          icon='"\f1d8"'
          name="clientMessageRoomForm-submit"
          type="submit"
          disabled={disabled}
        />
      </Wrapper>
    </Outer>
  );
};

const height = "41px";

const Outer = styled.div`
  width: 100%;
  border-top: 1px solid ${ConstColor.PlaceholderAndBorder};
  background-color: ${ConstColor.White};
  padding: 20px;
`;

const Wrapper = styled.div`
  display: flex;
  align-items: flex-end;
  // max-width: ${ConstWidth.ContentsMaxWidth};
  margin: auto;
`;

const ErrorTxt = styled(ParagraphSup)`
  color: ${ConstColor.Corporate};
`;

const Label = styled.label`
  display: none;
  @media screen and (min-width: ${ConstBreakPoint.Default}) {
    display: block;
  }
`;

const FileBtn = styled(BtnBorderLarge)`
  display: flex;
  justify-content: center;
  align-items: center;

  margin-right: 20px;

  height: ${height};
  line-height: ${height};
`;

const SubmitBtn = styled(BtnCorporateLarge)`
  margin-left: 10px;

  height: ${height};
  line-height: ${height};
`;

const Input = styled.input`
  display: none;
`;

export default MessagePost;



// WEBPACK FOOTER //
// ./src/presentation/common/organism/message_room/message_post.tsx